<template>
  <div id="standards-home">
    <v-card flat>
      <v-img
        :src="titleImg"
        max-height="200"
        aspect-ratio=1.5
        position="center left"
        gradient="to right, rgba(0,0,0,.44), rgba(0,0,0,.44)"
      />
    </v-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      titleImg: 'https://images.unsplash.com/photo-1512627028095-2f0dc8a75786?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=1f62556826165a5be99e16ef9367c5a6&auto=format&fit=crop&w=1350&q=80'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/standards/Standards.vue